import { useSelector } from 'react-redux';
import { ExareStatus } from '@websky/graphql';
import { getRequestIsAutomaticMode, getRequestPrices, getRequestStatus, getTicketPrice } from '../model';
import { useRefundInsurancePrices } from './useRefundInsurancePrices';
export const useRequestPrice = () => {
    const prices = useSelector(getRequestPrices);
    const status = useSelector(getRequestStatus);
    const ticketPrice = useSelector(getTicketPrice);
    const isAutomaticMode = useSelector(getRequestIsAutomaticMode);
    const insurancePrices = useRefundInsurancePrices();
    const showPrices = prices && (status !== ExareStatus.InProcess || isAutomaticMode);
    return {
        prices,
        showPrices,
        ticketPrice,
        additionalPrices: insurancePrices
    };
};
